module.exports = __webpack_public_path__ + "static/media/woman_with_cat.52ba2b8a.png";